import React from 'react'
import { observer } from 'mobx-react'
import { useEnvValue } from '@morningtrain/react-helpers'
import Type from 'app/React/ProductForm/Type'

function Types(props){
  const [types] = useEnvValue('types',[])
  const items = types.map((k,i) => <Type key={i} onChange={props.onChange} type={types[i]}/>)

  const classes = function(){
    let classes = [
      'mtt-variations__radio-buttons',
      'mtt-variations__radio-buttons--half'
    ];

    return classes
  }

  return (
    <div className={classes().join(' ')}>
      {items.length > 0 ? items : null}
    </div>
  )
}

export default observer(Types)